import { render, staticRenderFns } from "./Viewer360.vue?vue&type=template&id=b55f1436&scoped=true&"
import script from "./Viewer360.vue?vue&type=script&lang=js&"
export * from "./Viewer360.vue?vue&type=script&lang=js&"
import style0 from "./Viewer360.vue?vue&type=style&index=0&id=b55f1436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55f1436",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
